void function(scope, factory) {
    if (typeof define === 'function' && define.amd) {
        define('jquery.noloPath/constants', ['jquery'], factory);
    }
    else {
        factory(scope.jQuery);
    }
}(window, function ($) {
    $.NOLO_PATH_CONSTANTS = {
        'geocApiUrl'              : '//geocoding.internetbrands.com/geocoding/api/v1.1/getCityStateZipCode',
        'getFormQuestionsDataUrl' : 'service/getFormQuestionsData',
        'submitBehaviorAjax'      : 'ajax',
        'submitBehaviorHybrid'    : 'hybrid',
        'submitBehaviorStatic'    : 'static',
        'formBehaviorStatic'      : 'static',
        'formBehaviorProgressive' : 'progressive',
        'ajaxCallRetry'           : 5,
        'ajaxCallRetryInterval'   : 1000,
        'renderInsertionMethods'  : ['html', 'after', 'before', 'append', 'prepend', 'replaceWith'],
        'aopDomainContact'        : {},
        'ga4EnabledAOPs'          : [],
        'ga4Crypto'               : {'method': '', 'cred': {}},
        'recaptchaSecret1'        : '$RECAPTCHA_SITE_KEY_1',
        'recaptchaSecret2'        : '$RECAPTCHA_SITE_KEY_2',
        'inlineErrorMessages': {
            'default': {
                // General Validations status codes
                '1' : { // NOLO_VALIDATOR_REQUIRED
                    'default'    : 'This is a required field.',
                    'checkbox'   : 'Choose at least 1 answer for this field.',
                    'radio'      : 'Choose 1 answer for this field.',
                },
                '2' : 'NOLO_VALIDATOR_STRING',
                '3' : 'NOLO_VALIDATOR_BOOLEAN',
                '4' : 'NOLO_VALIDATOR_INTEGER',
                '5' : 'NOLO_VALIDATOR_NUMBER',
                '6' : 'NOLO_VALIDATOR_COMPARE',
                '7' : 'NOLO_VALIDATOR_RANGE',
                '8' : 'NOLO_VALIDATOR_REGULAR_EXPRESSION',
                '9' : 'NOLO_VALIDATOR_DATE',
                '10' : 'Please check your email and resubmit.',
                '11' : 'NOLO_VALIDATOR_URL',
                '12' : 'NOLO_VALIDATOR_FILE',
                '13' : 'NOLO_VALIDATOR_IMAGE',
                '14' : 'NOLO_VALIDATOR_EXIST',
                '15' : 'NOLO_VALIDATOR_UNIQUE',
                '16' : 'NOLO_VALIDATOR_CAPTCHA',
                '100' : {
                    'default' : 'NOLO_VALIDATOR_WHITELISTED',
                    'userip'  : 'We are not able to process your request.',
                },
                '101' : {
                    'default' : 'NOLO_VALIDATOR_BLACKLISTED',
                    'case_description': 'Please check your case description and resubmit.',
                    'first_name' : 'Please check your name and resubmit.',
                    'last_name'  : 'Please check your name and resubmit.',
                    'mail'    : 'Please check your email and resubmit.',
                    'phone'   : 'Please check your phone number and resubmit.',
                    'userip'  : 'We are not able to process your request.',
                },
                '102' : {
                    // NOLO_VALIDATOR_DUPLICATE
                    'default'    : 'A request matching the provided contact information has already been submitted to local professionals in our network.',
                    'first_name' : 'Please check your name and resubmit.',
                    'last_name'  : 'Please check your name and resubmit.',
                    'mail'       : 'Please check your email and resubmit.',
                    'phone'      : 'Please check your phone number and resubmit.',
                },
                '103' : {
                    //'NOLO_VALIDATOR_REGEX'
                    'default'    : 'Invalid format for this field.',
                    'first_name' : 'Please check your name and resubmit.',
                    'last_name'  : 'Please check your name and resubmit.',
                    'mail'       : 'Please check your email and resubmit.',
                    'phone'      : 'Please enter a valid phone number.',
                },
                '104' : 'NOLO_VALIDATOR_MAX_REQUEST',
                '105' : 'NOLO_VALIDATOR_MAX_FINISHED_REQUEST',
                '106' : 'Cannot process your submission because the current session has expired. Please try again.', // NOLO_VALIDATOR_SKEY
                '107' : {
                    'default' : 'NOLO_VALIDATOR_ZIP',
                    'zip'     : 'Please check your zip and resubmit.',
                },
                '108' : {
                    'default'          : 'NOLO_VALIDATOR_AOP',
                    'practice_area_id' : 'This practice area is not configured for use with this domain.',
                },
                '109' : 'NOLO_VALIDATOR_QUESTION',
                '110' : 'NOLO_VALIDATOR_ANSWER',

                // Phone Validation status codes
                '201' : 'Please check your phone number and resubmit.', // NOLO_VALIDATOR_PHONE_FORMAT
                '202' : 'Please check your phone number and resubmit.', // NOLO_VALIDATOR_PHONE_AREACODE (Melissa Data)
                '203' : 'Please check your phone number and resubmit.', // NOLO_VALIDATOR_PHONE_PREFIX (Melissa Data)
                '204' : 'Please enter a valid phone number.', // NOLO_VALIDATOR_PHONE_AREACODE_AND_PREFIX (Melissa Data)
                '205' : 'Please check your phone number and resubmit.', // NOLO_VALIDATOR_PHONE_TWILIO

                // Name Validation status codes
                '301' : 'Please check your name and resubmit.', // NOLO_VALIDATOR_NAME_SPACE_BEFORE
                '302' : 'Please check your name and resubmit.', // NOLO_VALIDATOR_NAME_SPACE_AFTER
                '303' : 'Please check your name and resubmit.', // NOLO_VALIDATOR_NAME_MULTI_SPACES
                '304' : 'Please check your name and resubmit.', // NOLO_VALIDATOR_NAME_ILLEGAL_CHAR

                // client-side required field error messaging
                'missing' : {
                    'default'    : 'This is a required field.',
                    'checkbox'   : 'Choose at least 1 answer for this field.',
                    'radio'      : 'Choose 1 answer for this field.',
                },

                'submit' : {
                    'default' : 'Please complete all questions to continue.',
                },

                // client-side invalid field format error messaging
                'invalid' : {
                    'default'    : 'Invalid format for this field.',
                    'zip'        : 'Invalid 5-digit US zip code.',
                    'email'      : 'Invalid email address format.',
                    'mail'       : 'Invalid email address format.',
                    'phone'      : 'Please enter a valid phone number.', // Invalid 10-digit US phone number
                    'first_name' : 'Invalid first name value.',
                    'last_name'  : 'Invalid last name value.',
                    'full_name'  : 'Invalid full name value.',
                    'integer'    : 'Invalid integer value.',
                    'number'     : 'Invalid number value.',
                    'email_valid': 'Please enter a valid Email',
                    'case_description': 'Please enter a valid Case Description',
                    'empty'      : ' ',
                },

                // client-side checks to determine if the server is working
                // @note:
                // + these messages will perform a full-stop since this application expects specific
                //   information to be present in order to work.
                'offline' : {
                    'default'      : 'Unable to process your request due to a server error. (ERROR unknown)',
                    'status_codes' : 'Unable to process your request due to a server error. (ERROR status_codes)',
                },

                // no-leadpath form loaded
                'no-leadpath' :{
                    'default': 'Unable to process your request. Please answer the question below.'
                },

                // default fallback error (you should not be getting this normally)
                'default' : 'This field has an unknown error.'
            },
            'es': {
                // General Validations status codes
                '1' : 'NOLO_VALIDATOR_REQUIRED',
                '2' : 'NOLO_VALIDATOR_STRING',
                '3' : 'NOLO_VALIDATOR_BOOLEAN',
                '4' : 'NOLO_VALIDATOR_INTEGER',
                '5' : 'NOLO_VALIDATOR_NUMBER',
                '6' : 'NOLO_VALIDATOR_COMPARE',
                '7' : 'NOLO_VALIDATOR_RANGE',
                '8' : 'NOLO_VALIDATOR_REGULAR_EXPRESSION',
                '9' : 'NOLO_VALIDATOR_DATE',
                '10' : 'Por favor revise su correo electrónico y vuelva a enviar.',
                '11' : 'NOLO_VALIDATOR_URL',
                '12' : 'NOLO_VALIDATOR_FILE',
                '13' : 'NOLO_VALIDATOR_IMAGE',
                '14' : 'NOLO_VALIDATOR_EXIST',
                '15' : 'NOLO_VALIDATOR_UNIQUE',
                '16' : 'NOLO_VALIDATOR_CAPTCHA',
                '100' : {
                    'default' : 'NOLO_VALIDATOR_WHITELISTED',
                    'userip'  : 'No podemos procesar su solicitud.',
                },
                '101' : {
                    'default' : 'NOLO_VALIDATOR_BLACKLISTED',
                    'case_description': 'Por favor revise su descripción del caso y vuelva a enviar.',
                    'first_name' : 'Por favor revise su nombre y vuelva a enviar.',
                    'last_name'  : 'Por favor revise su nombre y vuelva a enviar.',
                    'mail'    : 'Por favor revise su correo electrónico y vuelva a enviar.',
                    'phone'   : 'Por favor revise su número telefónico y vuelva a enviar.',
                    'userip'  : 'No podemos procesar su solicitud.',
                },
                '102' : {
                    // NOLO_VALIDATOR_DUPLICATE
                    'default'    : 'A request matching the provided contact information has already been submitted to local professionals in our network.',
                    'first_name' : 'Por favor revise su nombre y vuelva a enviar.',
                    'last_name'  : 'Por favor revise su nombre y vuelva a enviar.',
                    'mail'       : 'Por favor revise su correo electrónico y vuelva a enviar.',
                    'phone'      : 'Por favor revise su número telefónico y vuelva a enviar.',
                },
                '103' : {
                    //'NOLO_VALIDATOR_REGEX'
                    'default'    : 'Formato invalid para este campo.',
                    'first_name' : 'Por favor revise su nombre y vuelva a enviar.',
                    'last_name'  : 'Por favor revise su nombre y vuelva a enviar.',
                    'mail'       : 'Por favor revise su correo electrónico y vuelva a enviar.',
                    'phone'      : 'Por favor revise su número telefónico y vuelva a enviar.',
                },
                '104' : 'NOLO_VALIDATOR_MAX_REQUEST',
                '105' : 'NOLO_VALIDATOR_MAX_FINISHED_REQUEST',
                '106' : 'No podemos procesar su solicitud porque su sesión ha expirado. Por favor intentelo de nuevo.', // NOLO_VALIDATOR_SKEY
                '107' : {
                    'default' : 'NOLO_VALIDATOR_ZIP',
                    'zip'     : 'Por favor revise su código postal y vuelva enviar.',
                },
                '108' : {
                    'default'          : 'NOLO_VALIDATOR_AOP',
                    'practice_area_id' : 'Esta area de práctica no está configurada para este dominio.',
                },
                '109' : 'NOLO_VALIDATOR_QUESTION',
                '110' : 'NOLO_VALIDATOR_ANSWER',

                // Phone Validation status codes
                '201' : 'Por favor revise su número telefónico y vuelva a enviar.', // NOLO_VALIDATOR_PHONE_FORMAT
                '202' : 'Por favor revise su número telefónico y vuelva a enviar.', // NOLO_VALIDATOR_PHONE_AREACODE (Melissa Data)
                '203' : 'Por favor revise su número telefónico y vuelva a enviar.', // NOLO_VALIDATOR_PHONE_PREFIX (Melissa Data)
                '204' : 'Por favor revise su número telefónico y vuelva a enviar.', // NOLO_VALIDATOR_PHONE_AREACODE_AND_PREFIX (Melissa Data)
                '205' : 'Por favor revise su número telefónico y vuelva a enviar.', // NOLO_VALIDATOR_PHONE_TWILIO

                // Name Validation status codes
                '301' : 'Por favor revise su nombre y vuelva a enviar.', // NOLO_VALIDATOR_NAME_SPACE_BEFORE
                '302' : 'Por favor revise su nombre y vuelva a enviar.', // NOLO_VALIDATOR_NAME_SPACE_AFTER
                '303' : 'Por favor revise su nombre y vuelva a enviar.', // NOLO_VALIDATOR_NAME_MULTI_SPACES
                '304' : 'Por favor revise su nombre y vuelva a enviar.', // NOLO_VALIDATOR_NAME_ILLEGAL_CHAR

                // client-side required field error messaging
                'missing' : {
                    'default'    : 'Este es un campo requerido.',
                    'checkbox'   : 'Escoja al menos una respuesta para este campo.',
                    'radio'      : 'Escoja una respuesta para este campo.',
                },

                // client-side invalid field format error messaging
                'invalid' : {
                    'default'    : 'Formato invalid para este campo.',
                    'zip'        : 'Código postal de estados unidos (5 dígitos) inválido.',
                    'email'      : 'Formato de dirección de correo inválido.',
                    'mail'       : 'Formato de dirección de correo inválido.',
                    'phone'      : 'Número telefónico de estados unidos inválido (10 dígitos).',
                    'first_name' : 'Nombre inválido.',
                    'last_name'  : 'Apellido inválido.',
                    'integer'    : 'Número entero inválido.',
                    'number'     : 'Número inválido.',
                },

                // client-side checks to determine if the server is working
                // @note:
                // + these messages will perform a full-stop since this application expects specific
                //   information to be present in order to work.
                'offline' : {
                    'default'      : 'No podemos procesar su solicitud debido a un error de servidor. (ERROR unknown)',
                    'status_codes' : 'No podemos procesar su solicitud debido a un error de servidor. (ERROR status_codes)',
                },

                // no-leadpath form loaded
                'no-leadpath' :{
                    'default': 'No se puede procesar su solicitud. Por favor responde la pregunta a continuación.'
                },

                // default fallback error (you should not be getting this normally)
                'default' : 'Este campo tiene un error desconocido.'
            },
            'recaptchaErrorMessages': {
                'start': 'Our bot detection thinks you might be a robot. Please ',
                'link': 'refresh the page',
                'end': ' and try to submit again.'
            },
            'recaptchaRefreshMessages': 'Thank you for refreshing the page. Please re enter your information. We apologize for the inconvenience and won’t ask you to do it again.'
        },
        'trustedFormAOPs'         : [67, 20992, 133, 10581, 1091, 1245, 1077, 19570, 27, 114, 1244, 10469, 8937, 1246, 1078, 5016, 9002, 17783, 81, 9004, 4976, 4774, 1089, 1088, 17, 77, 66, 37, 9002, 397546, 130, 126, 13, 169071, 1081]    
    };
    var talc_bm_validator_required = {
    };
    var talc_bm = $.NOLO_PATH_CONSTANTS.inlineErrorMessages.default;
    talc_bm[1] = {
        'default'    : 'Required to answer',
        'checkbox'   : 'Choose at least 1 answer for this field.',
        'radio'      : 'Choose 1 answer for this field.',
        'custom_radio_input'      : 'Required to answer',

    };
    talc_bm.missing = talc_bm[1];
    talc_bm.missing.first_name = 'Please enter your first name';
    talc_bm.missing.last_name = 'Please enter your last name';
    talc_bm.missing.mail = 'Please enter your email';
    talc_bm.missing.phone = 'Please enter your phone';
    $.NOLO_PATH_CONSTANTS.inlineErrorMessages.talcumpowder_form3bm = talc_bm;
    
});
